export default __webpack_public_path__ + "static/media/element_spec_96.7ee76048.webp";